import { useExportMasterParam, useMasterParams } from "@/api/master-param";
import { TableCell } from "@/components/table/table-cell";
import { TableDefault } from "@/components/table/table-default";
import { TableForm } from "@/components/table/table-form";
import { TableHeaderFilter } from "@/components/table/table-header-filter";
import {
  DataConfig,
  useDefaultDataConfig,
} from "@/components/table/useDefaultDataConfig";
import { DownloadButton } from "@/components/ui/button";
import { generateCustomSpec } from "@/utils/helper";
import { swalErrorDefault } from "@/utils/lib/swal";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useCurrentUser } from "../auth/useCurrentUser";
import { ROLE } from "@/utils/constant";
import { nullElement } from "@/components/null-element";

const customSpec = generateCustomSpec({
  path: "",
  canBulk: false,
  fields: [
    {
      name: "paramType",
      label: "Param Type",
    },
    {
      name: "paramTag",
      label: "Param Tag",
    },
    {
      name: "value",
      label: "Value",
    },
    {
      name: "description",
      label: "Description",
    },
    {
      name: "active",
      label: "Status",
      select_options: {
        options: [
          { key: "true", label: "Active" },
          { key: "false", label: "Inactive" },
        ],
      },
    },
    {
      name: "value2",
      label: "Value 2",
    },
    {
      name: "createdByName",
      label: "Created By",
    },
    {
      name: "createdDate",
      label: "Created Date",
    },
    {
      name: "updatedByName",
      label: "Updated By",
    },
    {
      name: "updatedDate",
      label: "Updated Date",
    },
  ],
});

const HeaderElement = ({ dataConfig }: { dataConfig: DataConfig }) => {
  const { mutate: exportList, isPending: isDownloading } =
    useExportMasterParam();

  const handleExport = () => {
    const params = {
      ...dataConfig,
      limit: undefined,
      page: undefined,
    };

    exportList(
      {
        config: params,
      },
      {
        onError: () => {
          swalErrorDefault.fire();
        },
      },
    );
  };
  return (
    <div className="flex items-center justify-end gap-2">
      <DownloadButton onClick={handleExport} loading={isDownloading} />
    </div>
  );
};

export function MasterParamTable() {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = Object.fromEntries(searchParams.entries());
  const { roles } = useCurrentUser();

  const isSysAdminView = roles.includes(ROLE.SYS_ADMIN_VIEW);

  const { dataConfig, setDataConfig } = useDefaultDataConfig(filters);

  const { data: masterParams, isLoading } = useMasterParams(dataConfig);

  const form = useForm();

  function resetFilter() {
    setSearchParams();
  }

  return (
    <>
      <TableForm
        form={form}
        setDataConfig={setDataConfig}
        createPath={isSysAdminView ? null : "/master-data/master-param/create"}
        createLabel="Add"
        handleResetFilter={resetFilter}
      />
      <TableDefault
        spec={customSpec}
        data={masterParams}
        dataConfig={dataConfig}
        setDataConfig={setDataConfig}
        loading={isLoading}
        customCell={TableCell}
        searchFilterByColumns={true}
        headerElement={<HeaderElement dataConfig={dataConfig} />}
        customFilterByColumns={TableHeaderFilter}
        customButtonEdit={isSysAdminView ? nullElement : undefined}
      />
    </>
  );
}
